import { render, staticRenderFns } from "./Efecty.vue?vue&type=template&id=260a363c"
import script from "./Efecty.vue?vue&type=script&lang=js"
export * from "./Efecty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports